import type { TableNode } from "@lexical/table";

export const getTableColumnWidths = (tableNode: TableNode): number[] => {
  let columnWidths = tableNode.getColWidths();

  // If this is a table created before we supported explicit column widths,
  // This value will be undefined, and the cols will also not have a width value
  // The table just equally divides the table width between the columns.
  // Therefore we need to calculate the widths of the columns for this function to continue.
  // NB the child of the table is the row, not the cells.
  // The widths also MUST add up to 100% of the table width with integers only.
  if (columnWidths === undefined) {
    const columnCount = tableNode.getColumnCount();

    const widthPerColumn = Math.round(100 / columnCount);
    // If we don't have 100% width then one column needs to be changed to make it add up
    // to 100%. Choose the last column to be the one that is changed.
    if (widthPerColumn * columnCount !== 100) {
      const lastColumnIndex = columnCount - 1;
      const lastColumnWidth = 100 - widthPerColumn * (columnCount - 1);
      columnWidths = Array.from({ length: columnCount }, (_, i) =>
        i === lastColumnIndex ? lastColumnWidth : widthPerColumn,
      );
    } else {
      // If we have 100% then just set the widths to be equal
      columnWidths = Array.from({ length: columnCount }, () => widthPerColumn);
    }
  }
  return [...columnWidths];
};

export const sumLeftPercentagesFromWidths = (widths: number[], limitIndex: number): number =>
  widths.reduce((acc, curr, index) => {
    if (index < limitIndex + 1) {
      return acc + curr;
    }
    return acc;
  }, 0);
